import _axios from '../../apiClient'

export function getPedido(payload) {
    return _axios.get(`/api/Pedido/GetPedidoBorradorPorUsuario`,
    { 
      params: { idUsuario: payload } 
    },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getPedidoById(id) {
  return _axios.get(`/api/Pedido/Get`, {
    params: { id },
    headers: { 
      'Content-Type': 'application/json;charset=UTF-8' 
    }
  })
  .then(response => response.data)
  .catch(error => {
    const data = error.response.data
    throw (data)
  });
}

export function getStatusPedidoById(id) {
  return _axios.get(`/api/Pedido/GetStatusPedidoById`, 
    {
      params: { id },
    },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch(error => {
      const data = error.response.data
      throw (data)
    });
}

export function updateEstadoPedidoById(id, nuevoEstado) {
  return _axios.post(`/api/Pedido/UpdateEstadoPedidoById`, 
    {
      id: id,
      nuevoEstadoId: nuevoEstado,
    },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => {
      const pedidoActualizado = response.data;
      return pedidoActualizado;
    })
    .catch(error => {
      const data = error.response.data;
      throw (data);
    });
}

export function getMediosDePagosActivosPayment() {
  return _axios.get(`/api/MedioPagoPayment/GetActivos`, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch(function (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  });
}

export function getGenerateSignature(externalId, amount, biller, gateway, availableBinInstallments) {
  return _axios.post(`/api/Pedido/GenerateSignature`, 
    {
      externalId,
      amount,
      biller,
      gateway,
      availableBinInstallments
    },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data.signature)
    .catch(error => {
      console.error("Error generando firma:", error.response && error.response.data ? error.response.data : error.message);
      throw error;
    });
}


export function addPedidoDetalle(payload) {
  
  return _axios.post(`/api/Pedido/UpdatePedido`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function removePedidoDetalle(payload) {
  return _axios.post(`/api/Pedido/QuitarPedidoDetalleBorrador`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function setPedidoDetalleReemplazo(payload) {
  return _axios.post(`/api/Pedido/SetPedidoDetalleReemplazo`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function updateEstadoPedidoAbandonado(payload) {
  return _axios.post(`/api/Pedido/UpdateEstadoPedidoAbandonado`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getPedidosByUser(payload) {
  return _axios.get(`/api/Pedido/GetPedidosByUser`,
  { 
    params: { idUsuario: payload.idUsuario } 
  },
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getPedidosByCliente(payload) {
  return _axios.get(`/api/Pedido/GetPedidosByCliente`,
  { 
    params: { idCliente: payload.idCliente } 
  },
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}
export function getPedidosBorradorByCliente(payload) {
  return _axios.get(`/api/Pedido/GetPedidoBorradorPorCliente`,
  { 
    params: { idUsuario: payload.idUsuario } 
  },
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function actualizarFechaPedidoBorrador(payload) {
  return _axios.get(`/api/Pedido/ActualizarFechaPedidoBorrador`,
    { 
      params: { idPedido: payload } 
    },
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function ConfirmarEliminarPedido(payload) {
  return _axios.post(`/api/Pedido/UpdateEstadoPedido`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
  }

export function ActualizarDataPedido(payload) {
  return _axios.post(`/api/Pedido/UpdateEstadoPedido`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
  }

export function obtenerMontoTotalACobrar(payload) {
  return _axios.post(`/api/Pedido/CalcularMontoTotalACobrar`, payload, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = (error.response && error.response.data) || error.message;
    throw data;
  });
}

  
export function setPedidoPagoMP(payload) {
  return _axios.post(`/api/Pedido/setPedidoPagoMP`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function generarCheckout(payload) {
  return _axios.post(`/api/Pedido/GenerarCheckoutMobbex`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function ConfirmarPedidoMobbex(payload) {
  return _axios.post(`/api/Pedido/ConfirmarPedidoMobbex`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function sendEmailConfirmado(payload) {
  return _axios.post(`/api/Pedido/SendEmailConfirmado`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getPreferenciasUltimoPedido(payload) {
  return _axios.get(`/api/Pedido/GetPreferenciasUltimoPedido`,
  { 
    params: { idCliente: payload.idCliente } 
  },
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}
